import { useEffect, useState } from "react";
import Container from "../common/Container";
import { navLinks } from "../../data/portfolioData";

const Navbar = () => {
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    // Clean up any hash left in the URL on mount
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }

    const sectionIds = navLinks
      .map((l) => l.href.replace("#", ""))
      .filter(Boolean);

    const observers = [];

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveSection(id);
            window.history.replaceState(null, "", `#${id}`);
          } else {
            setActiveSection((prev) => {
              if (prev === id) {
                // No section is active — clear the hash
                window.history.replaceState(null, "", window.location.pathname);
                return "";
              }
              return prev;
            });
          }
        },
        { threshold: 0.4 },
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <nav>
      <Container>
        <a
          className="nav-logo"
          href={window.location.pathname}
          aria-label="Go to homepage"
        >
          XH<span>.</span>
        </a>

        <ul className="nav-links">
          {navLinks.map((link) => {
            const id = link.href.replace("#", "");
            return (
              <li key={link.href}>
                <a
                  href={link.href}
                  className={activeSection === id ? "active" : ""}
                >
                  {link.label}
                </a>
              </li>
            );
          })}
        </ul>

        <div className="nav-dot" aria-hidden="true" />
      </Container>
    </nav>
  );
};

export default Navbar;
